<div class="step_3_container">
  <h5 style="text-align: center;">OTP Validation</h5>
  <p style="text-align: center;">Please confirm the initiation of the Change Request by validating OTP</p>
  <div class="row">
    <div class="form-group">
      <input type="text" class="form-control" [(ngModel)]="cr_data['otp']">
    </div>
  </div>
</div>